import React from "react";

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const HalfFilledCircle: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="4.5" cy="4.5" r="4" fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 8C6.433 8 8 6.433 8 4.5C8 2.567 6.433 1 4.5 1C2.567 1 1 2.567 1 4.5C1 6.433 2.567 8 4.5 8ZM4.5 9C6.98528 9 9 6.98528 9 4.5C9 2.01472 6.98528 0 4.5 0C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9Z"
        fill="currentColor"
      />
      <path
        d="M4.5 0C6.98528 0 9 2.01472 9 4.5C9 6.98528 6.98528 9 4.5 9V0Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default HalfFilledCircle;
